import React from 'react';
import Button from 'src/components/Button/Button';
import './SuccessCard.scss';

interface SuccessCardProps {
  fileName: string;
  onUploadAnother: () => void;
}

export const SuccessCard = ({
  fileName,
  onUploadAnother,
}: SuccessCardProps) => (
  <div className="sc_container">
    <div className="sc_icon_wrap">
      <span className="sc_icon">✓</span>
    </div>
    <p className="sc_headline">Uploaded successfully</p>
    {fileName && (
      <div className="sc_file_chip">
        <span>📄</span>
        <span>{fileName}</span>
      </div>
    )}
    <div className="sc_progress_bar">
      <div className="sc_progress_bar_fill" />
    </div>
    <p className="sc_note">
      Your backup file has been received. Processing may take 30–45 minutes —
      please review the associated unit to confirm that the walkthrough has been
      restored.
    </p>
    <Button label="Upload Another" onClick={onUploadAnother} size="small" />
  </div>
);
